<!-- Outer page: white background (Figma design) -->
<div class="hp-outer-page">

  <!-- Phone frame: white column, max-width 440px, centered -->
  <div class="hp-phone-frame">

    <!-- Scrollable main content -->
    <main class="hp-main" role="main">

      <!-- Logo block -->
      <div class="hp-logo-block">
        <h1 class="hp-logo-title">
          <img src="assets/healthpicks/images/logo.svg" alt="Health Picks" class="hp-logo-img" />
        </h1>
      </div>

      <!-- Input area -->
      <div class="hp-input-area">

        <!-- Server-side error (wrong credentials) -->
        <app-healthpicks-error-banner
          [message]="errorMessages.login.password && !errorMessages.login.email ? errorMessages.login.password : ''">
        </app-healthpicks-error-banner>

        <form class="hp-login-form" (ngSubmit)="login()" novalidate>

          <!-- Fields container -->
          <div class="hp-fields">

            <!-- Email field -->
            <div class="hp-field-group" [class.hp-field-group--error]="errorMessages.login.email">
              <label class="hp-field-group__label" for="login-email">メールアドレス</label>
              <div class="hp-field-group__input-wrap">
                <input
                  type="email"
                  id="login-email"
                  name="email"
                  [(ngModel)]="email"
                  placeholder="demo@healthpicks.com"
                  autocomplete="email"
                  autocapitalize="off"
                  class="hp-field-group__input"
                />
              </div>
              <app-healthpicks-field-error [message]="errorMessages.login.email"></app-healthpicks-field-error>
            </div>

            <!-- Password field -->
            <div class="hp-field-group" [class.hp-field-group--error]="passwordFieldError">
              <label class="hp-field-group__label" for="login-password">パスワード</label>
              <!-- Figma ● (U+25CF) via mirror; real value in transparent text input -->
              <div class="hp-field-group__input-wrap hp-pw-wrap">
                <span
                  class="hp-pw-mirror"
                  *ngIf="!isPasswordVisible"
                  [class.hp-pw-mirror--placeholder]="!password?.length && !passwordFieldFocused"
                  aria-hidden="true"
                >{{ passwordMirrorText }}</span>
                <input
                  #passwordInput
                  type="text"
                  id="login-password"
                  name="password"
                  autocomplete="current-password"
                  autocapitalize="off"
                  spellcheck="false"
                  (input)="onPasswordBulletInput($event)"
                  (focus)="onPasswordFocus()"
                  (blur)="onPasswordBlur()"
                  class="hp-pw-entry"
                  [class.hp-pw-entry--visible]="isPasswordVisible"
                />
                <!-- Eye toggle -->
                <button
                  type="button"
                  class="hp-pw-eye"
                  [class.hp-pw-eye--has-value]="password?.length"
                  (click)="togglePasswordVisibility()"
                  aria-label="パスワードの表示を切り替える"
                  tabindex="-1"
                >
                  <!-- Eye icon (shown when password is hidden) -->
                  <svg *ngIf="!isPasswordVisible" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z"/>
                  </svg>
                  <!-- Eye-off icon (shown when password is visible) -->
                  <svg *ngIf="isPasswordVisible" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M11.83,9L15,12.16C15,12.11 15,12.05 15,12A3,3 0 0,0 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12A3,3 0 0,0 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17A5,5 0 0,1 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.08L19.73,22L21,20.73L3.27,3M12,7A5,5 0 0,1 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.28,4.5 8.67,4.9 7.24,5.65L9.27,7.68C10.12,7.25 11.03,7 12,7Z"/>
                  </svg>
                </button>
              </div>
              <app-healthpicks-field-error [message]="passwordFieldError"></app-healthpicks-field-error>
            </div>

            <!-- Remember email checkbox (Figma 5817-1968: 16x16 border-box, gap 8px, centered) -->
            <div class="hp-remember-row">
              <label class="hp-checkbox-label" for="save-email">
                <span class="hp-checkbox-icon-wrap">
                  <input
                    type="checkbox"
                    id="save-email"
                    class="hp-checkbox-input-hidden"
                    [(ngModel)]="isSaveEmail"
                    name="isSaveEmail"
                  />
                  <!-- Figma: 16x16, border #292929 1px, radius 2px; checked: teal fill + white tick -->
                  <span class="hp-checkbox-box" [class.hp-checkbox-box--checked]="isSaveEmail" aria-hidden="true"></span>
                </span>
                <span class="hp-checkbox-label__text">メールアドレスを保存する</span>
              </label>
            </div>

          </div><!-- /hp-fields -->

          <!-- Action area -->
          <div class="hp-actions">

            <!-- Login button -->
            <button
              type="submit"
              id="btn-login"
              class="hp-btn-login"
              [disabled]="!email || !password"
            >
              ログイン
            </button>

            <!-- Forgot password -->
            <div class="hp-forgot">
              <span class="hp-forgot__text">パスワードをお忘れの方</span>
              <button type="button" class="hp-forgot__link" (click)="navigate('forgot-password')">
                パスワード再設定
              </button>
            </div>

          </div><!-- /hp-actions -->

        </form>

      </div><!-- /hp-input-area -->

    </main>
  </div><!-- /hp-phone-frame -->
</div><!-- /hp-outer-page -->
